import { useQuery } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';
import type { StoreSettings } from '../types';

export const DEFAULT_SETTINGS: StoreSettings = {
  storeName: 'Orenyva',
  announcementBarText: 'GOOD HABITS, A BRIGHTER TOMORROW',
  announcementBarEnabled: true,
  socialLinks: {},
  freeShippingThreshold: 45,
};

export function useSettings() {
  return useQuery({
    queryKey: ['settings'],
    queryFn: () => settingsService.get(),
    staleTime: 10 * 60 * 1000,
    retry: false,
    placeholderData: DEFAULT_SETTINGS,
  });
}
